import React from 'react';
import Marquee from "react-fast-marquee";
import News from "./components/news";
import useLatestNews from "../../../hooks/public/useLatestNews";

const LatestNews = () => {
    const {data} = useLatestNews();
    const speed = 50;
    const pauseOnHover = true;
    const gradient = false;

    return (
        <section className="latest-news-section">
            <div className="d-flex align-items-center latest-news-container">
                <div className="latest-news-title">Latest News</div>
                <div className="all-latest-news">
                    <ul className="d-flex mb-0 pl-0">
                        <Marquee gradient={gradient} pauseOnHover={pauseOnHover} speed={speed}>
                            {data && data.map((news) => <News key={news.id} news={news}/>)}
                        </Marquee>
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default LatestNews;
